import { StringUtil } from './../../util/string-util';
import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, UntypedFormControl, ValidationErrors, Validator } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { CustomValidators } from '../../validators/custom-validators';
import { SolicitacaoService } from 'src/app/core/apis/solicitacao/solicitacao.service';

@Component({
    selector: 'app-nro-processo-input',
    templateUrl: './nro-processo-input.component.html',
    providers: [
        provideNgxMask(),
        provideAnimations(),
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => NroProcessoInputComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => NroProcessoInputComponent),
            multi: true
        }
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        NgxMaskDirective
    ]
})
export class NroProcessoInputComponent implements ControlValueAccessor, Validator {
  @Input() tipoOrdem: string;
  @Input() tokenIam: string;

  isValidating = false;

  control = new UntypedFormControl('', [
    CustomValidators.validatorNroProcesso
  ]);

  onTouched: () => void = () => {};
  onChange: (_: any) => void = () => {};

  constructor(private solicitacaoService: SolicitacaoService) {
    this.control.valueChanges.subscribe(value => {
      const rawValue = StringUtil.removeNonNumber(value);
      if (rawValue?.length === 20) {
        this.control.setErrors({ aguardandoValidacao: true });
        this.control.markAsTouched({onlySelf: true});
        this.validarNumeroProcesso();
      }
    });
  }

  writeValue(value: any): void {
    this.control.setValue(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.control.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.control.disable() : this.control.enable();
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.control.errors;
  }

  validarNumeroProcesso(): void {
    const rawValue = StringUtil.removeNonNumber(this.control.value);
    if (rawValue?.length === 20) {
      this.solicitacaoService.validarNumeroProcesso(rawValue, this.tokenIam).subscribe({
        next: () => {
          this.control.setErrors(null);
          this.onChange(this.control.value);
          this.onTouched();
        },
        error: () => {
          this.control.setErrors({ valueInvalidError: true });
          this.onChange(this.control.value);
          this.onTouched();
        }
      });
    }
  }
}

